<template>
	<div class="ct-detail">
		<div class="ct-head">
			<v-icon small class="mr-1">mdi-cart-outline</v-icon>
			<span class="ct-head-title">Carrello di {{ cliente }}</span>
			<span class="ct-muted ml-2">ultima attività {{ dataOra }}</span>
			<v-spacer></v-spacer>
			<v-btn v-if="haScheda" x-small outlined color="primary" @click="$emit('open-customer')"><v-icon left x-small>mdi-account-box-outline</v-icon>Scheda cliente</v-btn>
		</div>

		<div class="ct-body">
			<div class="ct-main">
				<div class="ct-section">Articoli nel carrello</div>
				<div v-if="!righe.length" class="ct-muted">Nessun prodotto</div>
				<div v-else class="ct-lines">
					<div v-for="r in righe" :key="r.key" class="ct-line" data-tour="cart-line">
						<div class="ct-thumb">
							<img v-if="r.immagine" :src="r.immagine" alt="" loading="lazy" />
							<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
						</div>
						<div class="ct-line-main">
							<div class="ct-line-title" :title="r.nome">{{ r.nome }}</div>
							<div class="ct-line-sub">
								<span>SKU {{ r.sku || '—' }}</span>
								<span v-if="r.variante"> · {{ r.variante }}</span>
							</div>
						</div>
						<div class="ct-line-qty" title="Quantità × prezzo di listino attuale">
							<span class="font-weight-bold">{{ r.qt }}</span
							><span class="ct-muted"> × {{ euro(r.prezzo) }}</span>
						</div>
						<div class="ct-line-price">{{ euro(r.totale) }}</div>
					</div>
					<div class="ct-total">
						<span>Valore stimato</span>
						<span>
							<strong>{{ euro(riepilogo.valore) }}</strong>
							<span class="ct-muted"> · {{ riepilogo.pezzi === 1 ? '1 pezzo' : riepilogo.pezzi + ' pezzi' }}</span>
						</span>
					</div>
				</div>
				<div class="ct-note">I prezzi sono quelli di listino attuali: il carrello non salva il prezzo del momento.</div>
			</div>

			<div class="ct-side">
				<div class="ct-section">Contatti</div>
				<div class="ct-contacts">
					<div v-if="email" class="ct-contact">
						<v-icon small color="primary">mdi-email-outline</v-icon>
						<a :href="'mailto:' + email" class="ct-link">{{ email }}</a>
						<v-btn x-small icon title="Copia email" @click="copia(email)"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
					</div>
					<div v-if="telefono" class="ct-contact">
						<v-icon small color="primary">mdi-phone-outline</v-icon>
						<span>{{ telefono }}</span>
						<v-btn v-if="whatsapp" x-small outlined color="green" class="ml-1" @click="$emit('whatsapp')"><v-icon left x-small>mdi-whatsapp</v-icon>WhatsApp</v-btn>
					</div>
					<div v-if="!email && !telefono" class="ct-muted">Nessun contatto in anagrafica</div>
				</div>

				<div class="ct-section mt-4">Indirizzi di spedizione</div>
				<div v-if="!indirizzi.length" class="ct-muted ct-small">Nessun indirizzo in anagrafica</div>
				<div v-for="(a, i) in indirizzi" :key="i" class="ct-address">
					<div class="font-weight-medium">
						{{ a.Name || cliente }}
						<v-chip v-if="a.default" x-small outlined color="primary" class="ml-1">predefinito</v-chip>
					</div>
					<div v-if="a.Street1 || a.Street2">{{ [a.Street1, a.Street2].filter(Boolean).join(', ') }}</div>
					<div>{{ [a.PostalCode, a.CityName, a.StateOrProvince].filter(Boolean).join(' ') }}</div>
					<div v-if="a.CountryName || a.Country" class="ct-muted">{{ a.CountryName || a.Country }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { euro, riepilogoCarrello } from './righeCarrello';

// dettaglio di un carrello abbandonato nella riga espansa (desktop) e nella card (mobile)
export default {
	name: 'CartDetail',
	props: {
		item: { type: Object, required: true },
		// righe gia' normalizzate da righeCarrello()
		righe: { type: Array, default: () => [] },
		// numero valido per WhatsApp (null = tasto nascosto)
		whatsapp: { type: String, default: null },
	},
	computed: {
		buyer() {
			return (this.item.customer && this.item.customer.buyer) || {};
		},
		cliente() {
			return [this.buyer.name, this.buyer.lastname].filter(Boolean).join(' ') || this.buyer.email || 'cliente';
		},
		haScheda() {
			return !!this.buyer.id;
		},
		email() {
			return this.buyer.email || '';
		},
		telefono() {
			return (this.item.customer && this.item.customer.phone) || '';
		},
		dataOra() {
			return this.item.created_at ? this.$moment(this.item.created_at).format('DD/MM/YYYY HH:mm') : '—';
		},
		riepilogo() {
			return riepilogoCarrello(this.righe);
		},
		// il predefinito per primo
		indirizzi() {
			const lista = (this.item.customer && this.item.customer.ShippingAddress) || [];
			return [...lista].sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0));
		},
	},
	methods: {
		euro,
		copia(testo) {
			if (navigator.clipboard) navigator.clipboard.writeText(testo);
		},
	},
};
</script>

<style scoped>
.ct-detail {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	width: 100%;
}
.ct-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.ct-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.ct-body {
	display: grid;
	grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
	gap: 16px;
	padding: 12px;
}
.ct-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.ct-muted {
	color: #5f6b7a;
}
.ct-small {
	font-size: 13px;
}
.ct-lines {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.ct-line {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 12px;
	font-size: 14px;
}
.ct-line + .ct-line {
	border-top: 1px solid #eef2f7;
}
.ct-line-main {
	flex: 1 1 auto;
	min-width: 0;
}
.ct-thumb {
	flex: 0 0 48px;
	width: 48px;
	height: 48px;
	border-radius: 6px;
	border: 1px solid #e1e7ef;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.ct-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.ct-line-title {
	font-weight: 500;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ct-line-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.ct-line-qty {
	flex: 0 0 auto;
	white-space: nowrap;
}
.ct-line-price {
	flex: 0 0 86px;
	text-align: right;
	font-weight: 600;
	white-space: nowrap;
}
.ct-total {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	padding: 8px 12px;
	background: #f7f9fc;
	border-top: 1px solid #e1e7ef;
	font-size: 14px;
}
.ct-note {
	font-size: 12px;
	color: #5f6b7a;
	margin-top: 6px;
}
.ct-contacts {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.ct-contact {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	min-width: 0;
}
.ct-link {
	color: inherit;
	text-decoration: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ct-link:hover {
	text-decoration: underline;
}
.ct-address {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 8px 12px;
	font-size: 13px;
	line-height: 1.5;
}
.ct-address + .ct-address {
	margin-top: 6px;
}

@media (max-width: 768px) {
	.ct-detail {
		margin: 0 -4px;
	}
	.ct-body {
		grid-template-columns: 1fr;
		padding: 8px;
	}
	.ct-line {
		flex-wrap: wrap;
		gap: 4px 12px;
	}
	.ct-line-main {
		flex-basis: calc(100% - 60px);
	}
	.ct-line-title {
		white-space: normal;
	}
	.ct-line-qty {
		flex: 1 1 auto;
	}
}
</style>
